export default {
    methods: {
        preloadQuestionImage (questions) {
            var images = []

            for (var questionIndex = 0; questionIndex < questions.length; questionIndex++) {
                if (questions[questionIndex].image) {
                    images.push(questions[questionIndex].image)
                }

                for (var answerIndex = 0; answerIndex < questions[questionIndex].answers.length; answerIndex++) {
                    if (questions[questionIndex].answers[answerIndex].image) {
                        images.push(questions[questionIndex].answers[answerIndex].image)
                    }
                }
            }

            var imageIns = []

            images.forEach(function (image, index) {
                imageIns[index] = new Image()
                imageIns[index].src = image
            })
        },

        preloadRankingImage () {
            var images = [
                require('@/assets/images/rank-1.png'),
                require('@/assets/images/rank-2.png'),
                require('@/assets/images/rank-3.png'),
            ]
            var imageIns = []

            images.forEach(function (image, index) {
                imageIns[index] = new Image()
                imageIns[index].src = image
            })
        }
    }
}
